const freshChatWidgetToken = process.env.NEXT_PUBLIC_FRESHCHAT_TOKEN;

/**
 * Hide the freshchat widget
 * This is called for admin layouts
 */
export const hideFreshchat = () => {
    try {
        var delaySetup = () => {
            if (window.fcWidget) {
                window.fcWidget.hide();
            } else {
                // Freshchat is not loaded, retry in a short time
                setTimeout(delaySetup, 500);
            }
        };
    } catch (e) {
        console.error('Failed to load freshchat', e);
    }
    if (freshChatWidgetToken !== 'FC-dummy') delaySetup();
};
